export const POSTS = [
  {
    render: (
      <blockquote
        className="instagram-media"
        data-instgrm-permalink="https://www.instagram.com/p/DAJM-j1hACU/?utm_source=ig_embed&amp;utm_campaign=loading"
        data-instgrm-version="14"
        style={{
          background: "#FFF",
          border: 0,
          borderRadius: "3px",
          boxShadow: "0 0 1px 0 rgba(0,0,0,0.5), 0 1px 10px 0 rgba(0,0,0,0.15)",
          margin: "1px",
          maxWidth: "540px",
          minWidth: "326px",
          padding: 0,
          width: "calc(100% - 2px)",
        }}
      >
        <div style={{ padding: "16px" }}>
          <a
            href="https://www.instagram.com/p/DAJM-j1hACU/?utm_source=ig_embed&amp;utm_campaign=loading"
            target="_blank"
            rel="noopener noreferrer"
            style={{ textDecoration: "none" }}
          >
            <div
              style={{
                color: "#3897f0",
                fontFamily: "Arial, sans-serif",
                fontSize: "14px",
                fontWeight: "550",
                lineHeight: "18px",
                textAlign: "center",
              }}
            >
              View this post on Instagram
            </div>
          </a>
        </div>
      </blockquote>
    ),
  },
  {
    render: (
      <blockquote
        className="instagram-media"
        data-instgrm-permalink="https://www.instagram.com/p/DAJMtHqhVM0/?utm_source=ig_embed&amp;utm_campaign=loading"
        data-instgrm-version="14"
        style={{
          background: "#FFF",
          border: 0,
          borderRadius: "3px",
          boxShadow: "0 0 1px 0 rgba(0,0,0,0.5), 0 1px 10px 0 rgba(0,0,0,0.15)",
          margin: "1px",
          maxWidth: "540px",
          minWidth: "326px",
          padding: 0,
          width: "calc(100% - 2px)",
        }}
      >
        <div style={{ padding: "16px" }}>
          <a
            href="https://www.instagram.com/p/DAJMtHqhVM0/?utm_source=ig_embed&amp;utm_campaign=loading"
            target="_blank"
            rel="noopener noreferrer"
            style={{ textDecoration: "none" }}
          >
            <div
              style={{
                color: "#3897f0",
                fontFamily: "Arial, sans-serif",
                fontSize: "14px",
                fontWeight: "550",
                lineHeight: "18px",
                textAlign: "center",
              }}
            >
              View this post on Instagram
            </div>
          </a>
        </div>
        <script async src="//www.instagram.com/embed.js"></script>
      </blockquote>
    ),
  },
  {
    render: (
      <blockquote
        className="instagram-media"
        data-instgrm-permalink="https://www.instagram.com/reel/DGNyWb7z_U-/?utm_source=ig_embed&amp;utm_campaign=loading"
        data-instgrm-version="14"
        style={{
          background: "#FFF",
          border: "0",
          borderRadius: "3px",
          boxShadow: "0 0 1px 0 rgba(0,0,0,0.5),0 1px 10px 0 rgba(0,0,0,0.15)",
          margin: "1px",
          maxWidth: "540px",
          minWidth: "326px",
          padding: "0",
          width: "99.375%",
        }}
      >
        <a
          href="https://www.instagram.com/reel/DGNyWb7z_U-/?utm_source=ig_embed&amp;utm_campaign=loading"
          style={{
            background: "#FFFFFF",
            lineHeight: "0",
            padding: "0",
            textAlign: "center",
            textDecoration: "none",
            width: "100%",
          }}
          target="_blank"
          rel="noopener noreferrer"
        >
          View this post on Instagram
        </a>
      </blockquote>
    ),
  },
  {
    render: (
      <blockquote
        className="instagram-media"
        data-instgrm-permalink="https://www.instagram.com/reel/DGNsCfszXv7/?utm_source=ig_embed&amp;utm_campaign=loading"
        data-instgrm-version="14"
        style={{
          background: "#FFF",
          border: "0",
          borderRadius: "3px",
          boxShadow: "0 0 1px 0 rgba(0,0,0,0.5),0 1px 10px 0 rgba(0,0,0,0.15)",
          margin: "1px",
          maxWidth: "540px",
          minWidth: "326px",
          padding: "0",
          width: "99.375%",
        }}
      >
        <a
          href="https://www.instagram.com/reel/DGNsCfszXv7/?utm_source=ig_embed&amp;utm_campaign=loading"
          style={{
            background: "#FFFFFF",
            lineHeight: "0",
            padding: "0",
            textAlign: "center",
            textDecoration: "none",
            width: "100%",
          }}
          target="_blank"
          rel="noopener noreferrer"
        >
          View this post on Instagram
        </a>
      </blockquote>
    ),
  },
  {
    render: (
      <blockquote
        className="instagram-media"
        data-instgrm-permalink="https://www.instagram.com/reel/DGLEXEzztIm/?utm_source=ig_embed&amp;utm_campaign=loading"
        data-instgrm-version="14"
        style={{
          background: "#FFF",
          border: "0",
          borderRadius: "3px",
          boxShadow: "0 0 1px 0 rgba(0,0,0,0.5),0 1px 10px 0 rgba(0,0,0,0.15)",
          margin: "1px",
          maxWidth: "540px",
          minWidth: "326px",
          padding: "0",
          width: "99.375%",
        }}
      >
        <a
          href="https://www.instagram.com/reel/DGLEXEzztIm/?utm_source=ig_embed&amp;utm_campaign=loading"
          style={{
            background: "#FFFFFF",
            lineHeight: "0",
            padding: "0",
            textAlign: "center",
            textDecoration: "none",
            width: "100%",
          }}
          target="_blank"
          rel="noopener noreferrer"
        >
          View this post on Instagram
        </a>
      </blockquote>
    ),
  },
  {
    render: (
      <blockquote
        className="instagram-media"
        data-instgrm-permalink="https://www.instagram.com/reel/DGH3Z-xzGKR/?utm_source=ig_embed&amp;utm_campaign=loading"
        data-instgrm-version="14"
        style={{
          background: "#FFF",
          border: "0",
          borderRadius: "3px",
          boxShadow: "0 0 1px 0 rgba(0,0,0,0.5),0 1px 10px 0 rgba(0,0,0,0.15)",
          margin: "1px",
          maxWidth: "540px",
          minWidth: "326px",
          padding: "0",
          width: "99.375%",
        }}
      >
        <a
          href="https://www.instagram.com/reel/DGH3Z-xzGKR/?utm_source=ig_embed&amp;utm_campaign=loading"
          style={{
            background: "#FFFFFF",
            lineHeight: "0",
            padding: "0",
            textAlign: "center",
            textDecoration: "none",
            width: "100%",
          }}
          target="_blank"
          rel="noopener noreferrer"
        >
          View this post on Instagram
        </a>
      </blockquote>
    ),
  },
  {
    render: (
      <blockquote
        className="instagram-media"
        data-instgrm-permalink="https://www.instagram.com/p/DF8OhshIc0l/?utm_source=ig_embed&amp;utm_campaign=loading"
        data-instgrm-version="14"
        style={{
          background: "#FFF",
          border: "0",
          borderRadius: "3px",
          boxShadow: "0 0 1px 0 rgba(0,0,0,0.5),0 1px 10px 0 rgba(0,0,0,0.15)",
          margin: "1px",
          maxWidth: "540px",
          minWidth: "326px",
          padding: "0",
          width: "99.375%",
        }}
      >
        <a
          href="https://www.instagram.com/p/DF8OhshIc0l/?utm_source=ig_embed&amp;utm_campaign=loading"
          style={{
            background: "#FFFFFF",
            lineHeight: "0",
            padding: "0",
            textAlign: "center",
            textDecoration: "none",
            width: "100%",
          }}
          target="_blank"
          rel="noopener noreferrer"
        >
          View this post on Instagram
        </a>
      </blockquote>
    ),
  },
];
